import { ListItemText, MenuItem } from '@material-ui/core';
import React from 'react';
import { RowMenuItemIcon } from './RowMenuItemIcon';

export type RowMenuItemProps = {
    onClick: VoidFunction
    icon?: React.ReactNode
    text: string
}

function RowMenuItemComponent ({ onClick, icon, text }: RowMenuItemProps) {
    return (
        <MenuItem onClick={onClick}>
            {
                icon !== undefined && <RowMenuItemIcon icon={icon} />
            }

            <ListItemText primary={text} />
        </MenuItem>
    )
}

export const RowMenuItem = React.forwardRef<any, RowMenuItemProps>((props, ref) => <RowMenuItemComponent {...props} />);